module.exports = __webpack_public_path__ + "teqbahn-assets/media/TeqbahnLabs10.a15689ba.png";